<template>
  <div class="content__main">NUXT Frontend App Health Check Works!</div>
</template>

<script>
export default {
  layout: 'health',

  data() {
    return {
      dataUI: {
        title: 'Frontend App Health Check Works!'
      }
    }
  },

  head() {
    return {
      title: this?.dataUI?.title,
      link: [{ rel: 'canonical', href: 'https://www.magazine.co.uk/jmagtest' }],
      meta: [
        {
          name: 'robots',
          content: 'NOINDEX,NOFOLLOW'
        }
      ]
    }
  }
}
</script>

<style lang="scss"></style>
